import request from '@/utils/request'

//创建任务
export function submitTask(data) {
  return request({
    url: '/school/class/tasks/publish',
    method: 'post',
    data
  })
}
//创建任务
export function getTask(id,page,limit) {
  return request({
    url: '/school/class/tasks?class_id='+id+'&page='+page+'&limit='+limit,
    method: 'get'
  })
}
